module.exports = __webpack_public_path__ + "static/media/spinner.40cd1b7c.gif";